import React, {FunctionComponent, useEffect} from "react";
import WizardStep from "../WizardStep";
import status0 from "../../../images/Progress/progress_auswahl.svg";
import PostalHint from "../../../commonComponents/PostalHint";
import {Grid, makeStyles} from "@material-ui/core";
import schmuck from "../../../images/ObjectTypes/button-schmuck.svg";
import uhr from "../../../images/ObjectTypes/button-uhr.svg";
import muenzenBarren from "../../../images/ObjectTypes/button-muenzen.svg";
import zahngold from "../../../images/ObjectTypes/button-zahngold.svg";
import diamanten from "../../../images/ObjectTypes/button-diamanten.svg";
import {setDisposalType} from "../../state/disposalSlice";
import {useDispatch} from "react-redux";
import SvgButton from "../../../commonComponents/SvgButton";
import {Step} from "../../WizardMap";
import {I18n} from "aws-amplify";
import {DisposalType} from "../../../API";
import {NavigationProps} from "../../slideRouter/navigationHook";

const useStyles = makeStyles(theme => ({
    container: {
        maxWidth: 380,
        [theme.breakpoints.down("xs")]: {
            maxWidth: 320,
            marginTop: 3
        }
    }
}));

const StepObjectType: FunctionComponent<NavigationProps> = ({gotoNextSlide}) => {

    const dispatch = useDispatch();
    const classes = useStyles();

    const selectDisposalType = (type: DisposalType, step: Step) => {
        dispatch(setDisposalType(type));
        gotoNextSlide(step);
    };

    /**
     * fix for iphone5
     * scrolling down if screen size equal or smaller iphone5,
     * to display last selectable type option
     */
    useEffect(() => {
        if (window.innerHeight <= 460) {
            setTimeout(() => window.scrollTo({
                top: 80,
                left: 0,
                behavior: "smooth"
            }), 1500);
        }
    }, []);

    return (
        <WizardStep title={I18n.get("steps")[Step.OBJECT_TYPE].title} icon={status0}>
            <Grid container spacing={4} className={classes.container} justify={"center"}>
                <Grid item>
                    <SvgButton
                        className={"jewellery"}
                        svg={schmuck}
                        onClick={() => selectDisposalType(DisposalType.JEWELLERY, Step.JEWELLERY_MATERIAL)}
                    />
                </Grid>
                <Grid item>
                    <SvgButton
                        svg={uhr}
                        className={"watch"}
                        onClick={() => selectDisposalType(DisposalType.WATCH, Step.WATCH_BRAND)}
                    />
                </Grid>
                <Grid item>
                    <SvgButton
                        svg={muenzenBarren}
                        onClick={() => selectDisposalType(DisposalType.COIN_BAR, Step.COIN_BAR_MATERIAL)}
                    />
                </Grid>
                <Grid item>
                    <SvgButton
                        svg={zahngold}
                        onClick={() => selectDisposalType(DisposalType.DENTAL_GOLD, Step.ADD_INFO)}
                    />
                </Grid>
                <Grid item>
                    <SvgButton
                        svg={diamanten}
                        onClick={() => selectDisposalType(DisposalType.DIAMOND, Step.ADD_INFO)}
                    />
                </Grid>
            </Grid>
            <PostalHint/>
        </WizardStep>
    );
};

export default StepObjectType;
